import { FALLBACK_STRING } from '../InfoItem/UserInfoField';

export function formatDetailValue(value: string | undefined | null): string {
  const trimmed = value?.trim();
  return trimmed ? trimmed : FALLBACK_STRING;
}
